module.exports = __webpack_public_path__ + "img/noImg2.f66c6839.png";